import AmadeusSeatmapService from './amadeus-seatmap-service';
import AmadeusSeatService from './amadeus-seat-service';

import './amadeus-seatmap-normalize.scss';
import './amadeus-seatmap.scss';

const MODULE_NAME = 'app.flight.seatmap.amadeus';
const module = angular.module(MODULE_NAME, [])
    .service('amadeusSeatmapService', AmadeusSeatmapService)
    .service('amadeusSeatService', AmadeusSeatService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/flights/flight-seatmap/amadeus-seatmap/amadeus-seatmap-module.js